/**
 * Sahara AudioSystem - Uses shared AudioSystem with Sahara-specific configuration
 *
 * PROPER APPROACH:
 * 1. Import the shared AudioSystem from the main engine
 * 2. Only define Sahara-specific configuration here
 * 3. No duplication of audio logic - all methods come from shared AudioSystem
 */

// Import the shared AudioSystem from the main engine
import {
  AudioSystem as SharedAudioSystem,
  AudioConfig,
} from '../../../engine/ecs/systems/AudioSystem';
import { ResourceManager } from '../../../engine/resources/ResourceManager';

// Sahara-specific audio configuration (ONLY configuration, no logic!)
const SAHARA_AUDIO_CONFIG: AudioConfig = {
  // Only override what's different from defaults
  // superpowerBackgroundMusic: 'super_power_background.wav', // No longer needed - default matches!

  // Volume settings for Sahara theme
  soundVolume: 0.6,
  musicVolume: 0.4,

  // Feature flags for Sahara
  enableSuperpowerMusic: true,
  enableSoundEffects: true,
  enableBackgroundMusic: true,
};

// Export the Sahara AudioSystem as a configured instance of the shared one
export class AudioSystem extends SharedAudioSystem {
  constructor(resourceManager: ResourceManager) {
    // Pass Sahara-specific config to the shared AudioSystem
    super(resourceManager, SAHARA_AUDIO_CONFIG);
  }
}
